<script>
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  name: 'PanelLoansFundedGraph',
  mixins: [reactiveProp],
  props: {
    options: Object,
  },

  mounted () {
    const options = Object.assign({}, this.options, {
      hover: { animationDuration: 0 },
      animation: {
        duration: 1,
        onComplete: () => {
          this.addBarLabels()
        },
      },
    })

    this.renderChart(this.chartData, options)
  },

  methods: {
    addBarLabels () {
      const chart = this.$data._chart
      chart.ctx.fillStyle = '#4E4E4E'
      chart.ctx.font = '14px Avenir Book'
      chart.ctx.textAlign = 'center'

      chart.getDatasetMeta(0).data.forEach((bar, i) => {
        const data = this.chartData.datasets[0].data[i]
        const label = this.$options.filters.currency(data)
        chart.ctx.fillText(label, bar._model.x, bar._model.y - 5)
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
